/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type HolidayExtent = typeof HolidayExtent[keyof typeof HolidayExtent];


export const HolidayExtent = {
  None: 'None',
  Half: 'Half',
  Full: 'Full',
} as const;
